/* eslint-disable @reatom/unit-naming-rule */
import { isAbortError } from '@reatom/framework'

import { Result } from '@blade/std-lib'
import { UnknownError, NotFoundError } from '@root/shared'
import {
  reatomFactoryCache,
  reatomResource,
  worthAskingAgain,
} from '@root/shared/lib'

import type { PremiumMetaModel } from '@root/entities/premium'

export const reatomPremiumBanner_ = ({
  premiumModel,
}: {
  premiumModel: PremiumMetaModel
}) => {
  const stateAtom = reatomResource(
    async (ctx, { reason }) => {
      const iconSrc = ctx.spy(premiumModel.banner)
      if (!iconSrc) {
        return Result.succeed(undefined)
      }

      try {
        const resolvedIconSrc =
          reason === 'retry' ? `${iconSrc}?retry=${Date.now()}` : iconSrc
        const response = await ctx.schedule(() => fetch(resolvedIconSrc))
        if (!response.ok) {
          if (response.status === 404) {
            return Result.fail(new NotFoundError())
          }

          return Result.fail(UnknownError.fromUnknown(response.status))
        }
        return Result.succeed(iconSrc)
      } catch (error) {
        if (isAbortError(error)) {
          throw error
        }
        return Result.fail(error)
      }
    },
    {
      retry: {
        enabled: true,
        strategy: 'exponential',
        // A missing logo stays missing; see `worthAskingAgain`.
        retryOn: worthAskingAgain,
      },
    },
  )

  return stateAtom
}

export const reatomPremiumBanner = reatomFactoryCache({
  factory: reatomPremiumBanner_,
  keyFn: ({ premiumModel }) =>
    premiumModel.currency.network + premiumModel.currency.address,
  clearOnDisconnect: false,
})
